// extracted by mini-css-extract-plugin
module.exports = {"bids":"BidsSection_bids__126H0"};